import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SnackbarContent from '@material-ui/core/SnackbarContent';

export default function ServerErrorSnackbar(props) {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={props.open}
      disableWindowBlurListener
      // autoHideDuration={2000}
      onExited={props.handleEraseServerError}
    >
      <SnackbarContent
        className="bc-red"
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar">
            <ErrorIcon />
            {props.message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={props.onClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}
